import { Dispatch, SetStateAction } from 'react';
import { createNamedContext } from '@utils';
import { GroupTagsContextValue, GroupTagsUpdateContextValue, GroupTagsResetContextValue } from './interfaces';

export const GroupTagsContext = createNamedContext<GroupTagsContextValue>(undefined, 'GroupTagsContext');
export const GroupTagsDispatchContext = createNamedContext<Dispatch<SetStateAction<GroupTagsContextValue>>>(undefined, 'GroupTagsDispatchContext');
export const GroupTagsUpdateContext = createNamedContext<GroupTagsUpdateContextValue>(undefined, 'GroupTagsUpdateContext');
export const GroupTagsResetContext = createNamedContext<GroupTagsResetContextValue>(undefined, 'GroupTagsResetContext');